import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  addComment: Subject<any> = new Subject();
  triggerNext: Subject<any> = new Subject();
  triggerBack: Subject<any> = new Subject();
  enableAddSection: Subject<any> = new Subject();

  constructor() {
  }
}
